import { PERMISSIONS } from '../../constants';
import list from './TaxAuditLogList';

export default {
  list,
  name: 'tax-audit-logs',
  permissions: [PERMISSIONS.TAX_AUDIT_LOG],
  options: { label: 'Auditoria de alterações nas taxas' }
}
